// extracted by mini-css-extract-plugin
export default {"eventContainer":"Zh5LAewX2NuYmLLAVVT6","eventName":"JkMIItXtCqtAJQ2L6vDf","planners":"AyOXTsyyu7AOJUvkTz7Q","eventJobfair":"RsoSxvrlSj6hwCijBuEY"};